import { Modal as CosmaModal } from 'is24-corecss';
import { Modal as Modals } from '@/components/common/display/modal/v3';
import type { BenefitModalProps } from '@/@types/benefitModalProps';
import { useIntl } from '@/i18n';
import { BenefitOverview } from '../shared/BenefitOverview';

const { V3: Modal } = Modals;

export const AdacActivationOfferModal = ({
  onClose,
  onActivate,
}: Pick<BenefitModalProps, 'onClose'> & {
  onActivate: () => void;
}) => {
  const { t } = useIntl();
  return (
    <Modal isVisible onClose={onClose}>
      <Modal.Header>
        <Modal.Title>{t({ id: 'benefits.adac.headline' })}</Modal.Title>
        <Modal.CloseButton />
      </Modal.Header>
      <Modal.Content>
        <BenefitOverview />
      </Modal.Content>
      <Modal.Footer>
        <CosmaModal.FooterButton
          variant='filledBrand'
          label={t({ id: 'benefits.adac.modal.activate' })}
          onClick={onActivate}
        />
      </Modal.Footer>
    </Modal>
  );
};
